import React from 'react';
import CarouselLinkpiles from './CarouselLinkpiles';
import NewLinkpiles from './NewLinkpiles';
import AbacusClientUtils from '@homeaway/abacus-client-utils';
import { Experiment } from '../Experiment';
import EdapModuleView from '../EdapModuleView';

import { MODULE_VIEW_EVENT_OPTIONS } from './events';

const CNAME = 'Linkpiles';

const handleModuleViewed = valueLP => () => {
  if (typeof valueLP === 'number') {
    AbacusClientUtils.evaluateExperimentAndLog('HA_PTA_HP_NewLinkPilesUI');
  }
};

const Linkpiles = props => (
  <Experiment name="HA_PTA_HP_NewLinkPilesUI">
    {valueLP => (
      <EdapModuleView
        eventOptions={MODULE_VIEW_EVENT_OPTIONS}
        onModuleViewed={handleModuleViewed(valueLP)}
        className={`${CNAME}__container`}
      >
        {valueLP ? <NewLinkpiles /> : <CarouselLinkpiles {...props} />}
      </EdapModuleView>
    )}
  </Experiment>
);

export default Linkpiles;


// WEBPACK FOOTER //
// ./src/universal/components/Linkpiles/Linkpiles.js